<div class="leitor-side-tools-row">
  <div
    *ngIf="!(breakpointLg$ | async)"
    class="leitor-side-tools-row leitor-side-tools-expansion-button"
    (click)="expansionLeitorSideTools($event)"
    [ngClass]="{
      openExpansion: openHover,
      closeExpansion: !openHover
    }"
  >
    <div class="leitor-side-tools-expansion-button-container">
      <mat-icon
        [svgIcon]="openHover ? 'chevron-right' : 'chevron-left'"
        class="leitor-side-tools-expansion-button-icon"
      >
      </mat-icon>
    </div>
  </div>

  <mat-accordion
    class="leitor-side-tools-align"
    multi
    [ngClass]="{
      openExpansion: openHover,
      closeExpansion: !openHover,
      transition: !transition
    }"
  >
    <mat-expansion-panel
      (opened)="togglePanelIndice(true)"
      (closed)="togglePanelIndice(false)"
      hideToggle
      class="leitor-side-tools-expansion-pane"
    >
      <mat-expansion-panel-header
        class="leitor-side-tools-expansion-pane-header all"
      >
        <mat-panel-title>
          <mat-icon
            svgIcon="list-tree"
            class="leitor-side-tools-icon transition"
            [ngClass]="{
              openExpansion: openHover,
              closeExpansion: !openHover
            }"
          ></mat-icon>

          <p class="leitor-side-texto noselect">Índice</p>
          <mat-icon
            [svgIcon]="panelindice ? 'chevron-up' : 'chevron-down'"
            class="leitor-side-tools-icon-chevron"
          >
          </mat-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-indice-sistematico
        class="leitor-side-tools-indice-sistematico"
      ></app-indice-sistematico>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="togglePanelTimer(true)"
      (closed)="togglePanelTimer(false)"
      hideToggle
      class="leitor-side-tools-expansion-pane"
    >
      <mat-expansion-panel-header
        class="leitor-side-tools-expansion-pane-header all"
      >
        <mat-panel-title>
          <mat-icon
            svgIcon="timer"
            class="leitor-side-tools-icon transition"
            [ngClass]="{
              openExpansion: openHover,
              closeExpansion: !openHover
            }"
          ></mat-icon>
          <p class="leitor-side-texto noselect">Timer</p>
          <mat-icon
            [svgIcon]="paneltimer ? 'chevron-up' : 'chevron-down'"
            class="leitor-side-tools-icon-chevron"
          >
          </mat-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-timer class="timer-wrapper"></app-timer>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="togglePanelBrain(true)"
      (closed)="togglePanelBrain(false)"
      hideToggle
      class="leitor-side-tools-expansion-pane"
    >
      <mat-expansion-panel-header
        class="leitor-side-tools-expansion-pane-header all"
      >
        <mat-panel-title>
          <mat-icon
            svgIcon="brain"
            class="leitor-side-tools-icon"
            [ngClass]="{
              openExpansion: openHover,
              closeExpansion: !openHover
            }"
          ></mat-icon>
          <p class="leitor-side-texto noselect transition">Dicas de estudo</p>
          <mat-icon
            [svgIcon]="panelbrain ? 'chevron-up' : 'chevron-down'"
            class="leitor-side-tools-icon-chevron"
          >
          </mat-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-dica-estudos></app-dica-estudos>
    </mat-expansion-panel>
    <!--
  <mat-expansion-panel
    (opened)="panelcircle = true"
    (closed)="panelcircle = false"
    hideToggle
    class="leitor-side-tools-expansion-pane"
  >
    <mat-expansion-panel-header
      class="leitor-side-tools-expansion-pane-header all"
    >
      <mat-panel-title>
        <mat-icon
          svgIcon="circle-nodes"
          class="leitor-side-tools-icon"
        ></mat-icon>
        <p class="leitor-side-texto noselect">Referências</p>
        <mat-icon
          [svgIcon]="panelcircle ? 'chevron-up' : 'chevron-down'"
          class="leitor-side-tools-icon-chevron"
        >
        </mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>conteudo</p>
  </mat-expansion-panel>

  <mat-expansion-panel
    (opened)="panelmessage = true"
    (closed)="panelmessage = false"
    hideToggle
    class="leitor-side-tools-expansion-pane"
  >
    <mat-expansion-panel-header
      class="leitor-side-tools-expansion-pane-header all"
    >
      <mat-panel-title>
        <mat-icon
          svgIcon="message-lines"
          class="leitor-side-tools-icon"
        ></mat-icon>
        <p class="leitor-side-texto noselect">Comentários</p>
        <mat-icon
          [svgIcon]="panelmessage ? 'chevron-up' : 'chevron-down'"
          class="leitor-side-tools-icon-chevron"
        >
        </mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>conteudo</p>
  </mat-expansion-panel>

  <mat-expansion-panel
    (opened)="paneltags = true"
    (closed)="paneltags = false"
    hideToggle
    class="leitor-side-tools-expansion-pane"
  >
    <mat-expansion-panel-header
      class="leitor-side-tools-expansion-pane-header all"
    >
      <mat-panel-title>
        <mat-icon svgIcon="tags" class="leitor-side-tools-icon"></mat-icon>
        <p class="leitor-side-texto noselect">Tags</p>

        <mat-icon
          [svgIcon]="paneltags ? 'chevron-up' : 'chevron-down'"
          class="leitor-side-tools-icon-chevron"
        >
        </mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>conteudo</p>
  </mat-expansion-panel>

  <mat-expansion-panel
    (opened)="panelplay = true"
    (closed)="panelplay = false"
    hideToggle
    class="leitor-side-tools-expansion-pane"
  >
    <mat-expansion-panel-header
      class="leitor-side-tools-expansion-pane-header all"
    >
      <mat-panel-title>
        <mat-icon
          svgIcon="clapperboard-play"
          class="leitor-side-tools-icon"
        ></mat-icon>
        <p class="leitor-side-texto noselect">Mídias</p>
        <mat-icon
          [svgIcon]="panelplay ? 'chevron-up' : 'chevron-down'"
          class="leitor-side-tools-icon-chevron"
        >
        </mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>conteudo</p>
  </mat-expansion-panel>
  -->
  </mat-accordion>
</div>
